/**
* Created by bieao on 2020/4/1.
*/
<template>
  <div id='home-bg'>
    <!--canvas背景-->
    <Background></Background>
    <!--头部-->
    <Header :projectInfo="projectInfo"></Header>
    <!--项目信息-->
    <ProjectInfo :projectInfo="projectInfo"></ProjectInfo>
    <!--概览-->
    <Overview :overview="craneOverview" ></Overview>
    <!--报警信息-->
    <AlarmMonitor :alarmList="alarmList" :peccancyList="peccancyList"></AlarmMonitor>
    <!--今日统计-->
    <StatisticsToday :data="staticsInfo"></StatisticsToday>
    <!--今日报警排名-->
    <StatisticsChart :alarmData="alarmChartData" :peccancyData="peccancyChartData"></StatisticsChart>
    <!--结构数据-->
    <CraneInformation :data="craneObj"></CraneInformation>
    <!--配电箱数据-->
    <BoxInfo v-if="craneObj.hasBox" :data="currentBox"></BoxInfo>
    <!--添加摄像头-->
    <Camera @showVideoDiv = 'showVideoDiv' :data="clickVideoObj"></Camera>
    <!--3D塔机-->
    <ThreeDQunCraneTwo :screenChange="isScreenChange" :cranes="cranes" :picture="projectPicture" :config="areaConfig" :runData = 'runData' @getVideoUrl = 'getVideoUrl' @initFinish="callRequest"></ThreeDQunCraneTwo>
    <!--展示视频-->
    <Video class="drag" v-drag v-if="showVideo" :addr="videoAddr" :videoTitle='videoTitle' :ysToken="ysToken" :craneName="craneName" @closeVideoDiv = 'closeVideoDiv'></Video>
    <!--知识产权-->
    <Bottom />
  </div>
</template>

<script>
import $ from 'jquery'
import dayjs from 'dayjs'
import Background from '@/components/Background'
import Header from '@/components/Header'
import ProjectInfo from '@/components/ProjectInfo'
import Overview from '@/components/Overview'
import AlarmMonitor from '@/components/AlarmMonitor'
import StatisticsToday from '@/components/StatisticsToday'
import StatisticsChart from '@/components/StatisticsChart'
import CraneInformation from '@/components/CraneInformation'
import BoxInfo from '@/components/BoxInfo'
import ThreeDQunCraneTwo from '@/components/ThreeDQunCraneTwo'
import Bottom from '@/components/Bottom'
import Video from '@/components/Video'
import Camera from '@/components/Camera'
import {
  getAlarmDetail,
  getBoxData,
  getBoxInfo,
  getBoxMetric,
  getConfig,
  getDayStaticData,
  getProject,
  getRealData,
  getRunData,
  getSingleProject,
  listProjectCrane,
  refreshToken,
  projectPicture,
  getYSToken
} from '@/api/metric'
import {compare, formatterNumber} from '@/utils/utils'

const formatter = 'YYYY-MM-DD'
const formatter2 = 'HH:mm:ss'
const alarmContent = {'is_overload': 'overload', 'is_smoke': 'smoke', 'is_overheat': 'overheat', 'is_disconnect': 'disconnect', 'is_blackout': 'blackout', 'is_leakage': 'leakage', 'is_resi': 'resi'}
const detailType = {
  '0': 'leftAntiCollision',
  '1': 'rightAntiCollision',
  '2': 'radiusOutAntiCollision',
  '3': 'radiusInAntiCollision',
  '4': 'leftSwingZoning',
  '5': 'rightSwingZoning',
  '6': 'radiusOutZoning',
  '7': 'radiusInZoning',
  '8': 'leftLimit',
  '9': 'rightLimit',
  '10': 'radiusOutLimit',
  '11': 'radiusInLimit',
  '12': 'heightUpLimit',
  '13': 'heightDownLimit',
  '14': 'force',
  '15': 'loadMoment',
  '16': 'windowSpeed'
}
export default {
  name: 'home',
  data () {
    return {
      clickIndex: 0,
      loopTimer: null, // 实时数据轮询
      craneTimer: null, // 塔机定时轮询
      staticRequestTimer: null, // 统计的轮询
      alarmRequestTimer: null, // 统计的轮询
      boxStatusTimer: null, // 配电箱数据的轮询
      showVideo: false,
      videoAddr: null, // 视频专用
      craneName: '', // 视频专用
      videoTitle: '', // 视频专用
      ysToken:null,
      craneObj: {
        id: null,
        alias: '', // 塔机名称
        towerHeight: 0, // 塔高
        craneType: 0, // 塔机类型
        jibArmLength: 0, // 起重臂长
        balanceArmLength: 0, // 平衡臂长
        craneFactoryName: '', // 厂商
        craneModelName: '', // 类型
        sectionLength: 0, // 标准节高度
        maxLoad: 0, // 额定吊重
        actualTowerHeight: 0,
        actualBalanceArmLength: 0,
        actualSectionHeight: 0
      }, // 当前点击的塔机
      alarmList: [], // 报警列表
      peccancyList: [], // 违章列表
      clickVideoObj: [],
      isClickClose: false,
      projectInfo: {
        id: null,
        companyId: null,
        name: null,
        status: 0,
        address: null,
        manager: null,
        managerMobile: null,
        safetyDirector: null,
        safetyDirectorMobile: null,
        companyName: null,
        description: null
      },
      craneOverview: {
        craneTotal: 0,
        online: 0,
        num110s: 0,
        numV610: 0
      },
      staticsInfo: {
        currentOnlineRate: 0,
        preOnlineRate: 0,
        currentAlarm: 0,
        currentTaJunAlarm: 0,
        preAlarm: 0,
        currentPeccancy: 0,
        currentTaJunPeccancy: 0,
        prePeccancy: 0,
        currentHangTimes: 0,
        currentTaJunHangTimes: 0,
        preHangTimes: 0,
        currentWorkTime: 0,
        currentTaJunWorkTime: 0,
        preWorkTime: 0
      },
      alarmChartData: [],
      peccancyChartData: [],
      data: {},
      cranes: [],
      runData: [],
      areaConfig: {},
      projectPicture: {},
      isScreenChange: Math.random(),
      craneCameraObj: [],
      boxes: {},
      currentBox: {
        boxName: null,
        currentA: 0,
        currentB: 0,
        currentC: 0,
        resi: 0,
        energyTotal: 0,
        leakagesValues: [],
        temperaturesValues: [],
        alarmList: []
      }
    }
  },
  components: {
    Background,
    Header,
    ProjectInfo,
    Overview,
    AlarmMonitor,
    StatisticsToday,
    StatisticsChart,
    CraneInformation,
    ThreeDQunCraneTwo,
    Video,
    Camera,
    Bottom,
    BoxInfo
  },
  methods: {
    getVideoUrl (craneId) {
      this.clearCraneTimer()
      this.timerClickRequest()
      this.craneObj = this.data[craneId]
      const {hasBox} = this.craneObj
      this.clickIndex = Object.keys(this.data).indexOf(craneId.toString())
      if (hasBox) this.getBoxBaseInfo()
      if (!this.showVideo) {
        this.clickVideoObj = this.craneCameraObj[craneId]
      }
    },
    closeVideoDiv () {
      this.showVideo = false
    },
    showVideoDiv (item) {
      if (item) {
        this.showVideo = true
        const {name, positionName, curQuality, ezopenUrl, ezopenHdUrl} = item
        this.craneName = name
        this.videoTitle = positionName
        this.videoAddr = curQuality ? ezopenHdUrl : ezopenUrl
      }
    },
    getProject (projectId) {
      if (!projectId) {
        getProject().then(res => {
          const {data, code} = res
          if (code === 200 && data.length === 1) {
            const id = data[0].id
            this.projectInfo = {...this.projectInfo, ...{id}}
            this.getSingleProject()
            this.getProjectCrane()
          }
        })
      } else {
        this.projectInfo = {...this.projectInfo, ...{id: projectId}}
        this.getSingleProject()
        this.getProjectCrane()
      }
    },
    getProjectCrane () {
      listProjectCrane(this.projectInfo.id).then(res => {
        const {data, code} = res
        if (code === 200 && data.length) {
          data.forEach((obj) => {
            const {id, alias, craneNvrList} = obj
            this.craneCameraObj[id] = (craneNvrList || []).map((item) => ({...item, name: alias}))
          })
          this.getConfig()
          this.getRealData()
          this.clearStaticTimer()
          this.getDayStaticData()
          this.timerStaticRequest()
          this.clearAlarmTimer()
          this.getAlarmDetail()
          this.getPeccancyDetail()
          this.timerAlarmAndPeccancyRequest()
        }
      })
    },
    getSingleProject () {
      getSingleProject(this.projectInfo.id).then(res => {
        const {data, code} = res
        if (code === 200 && !!data) {
          this.projectInfo = {...this.projectInfo, ...data}
          this.getProjectDayStaticData()
        }
      })
    },
    getConfig () {
      const {id} = this.projectInfo
      getConfig(id).then(res => {
        const {data, code} = res
        if (code === 200) {
          let initOk = []
          const {screenRect = {}, craneList = []} = data
          const newCraneList = craneList.filter((obj) => !!obj.mainSn)
          newCraneList.forEach((item) => {
            const {id, actualTowerHeight, actualBalanceArmLength, actualSectionHeight, jibArmLength, balanceArmLength, alias, initStatus, boxHashId, boxName, bindDriverList = []} = item
            const hasVideo = !!this.craneCameraObj[id].length
            const hasBox = !!boxHashId
            const currentDriver = bindDriverList.length ? bindDriverList[0].name : null
            const newObj = {...item, ...{craneId: id, armLength: jibArmLength, balanceArm: balanceArmLength, name: alias, hasVideo, hasBox, boxHashId, boxName, currentDriver, boxOnline: false, actualTowerHeight, actualBalanceArmLength, actualSectionHeight}}
            if (initStatus) {
              this.data[id] = newObj
              initOk.push(newObj)
            }
            if (boxHashId) {
              this.boxes[id] = {id, boxHashId}
            }
          })
          if (initOk.length) {
            this.craneObj = initOk[0]
            this.areaConfig = screenRect
            this.cranes = initOk
            this.getProjectPicture()
            if (this.craneObj.hasBox) {
              this.getBoxBaseInfo()
            }
          }
        }
      })
    },
    // 显示图片底图
    getProjectPicture () {
      const {id} = this.projectInfo
      projectPicture(id).then(res => {
        const {data, code} = res
        if (code === 200) {
          this.projectPicture = data
        }
      })
    },
    // 获取实时数据
    getRunData () {
      const {id} = this.projectInfo
      getRunData(id).then(res => {
        const {data, code} = res
        if (code === 200) {
          const newData = []
          data.forEach((obj) => {
            const {id, angle, loadWeight} = obj
            let oldObj = this.data[id]
            if (oldObj) {
              const {boxOnline} = oldObj
              newData.push({...obj, ...{craneId: id, rotationAngle: angle, loadValue: loadWeight, boxOnline}})
            }
          })
          this.runData = newData
        }
      })
    },
    // 获取配电箱的在线状态
    getBoxStatusData () {
      const keys = Object.keys(this.boxes)
      const values = Object.values(this.boxes)
      const ids = values.map((item) => item.boxHashId)
      if (!ids.length) return
      getBoxData(ids).then(res => {
        const {result, code} = res
        if (code === 200) {
          const obj = {}
          result.forEach((item) => {
            const {boxHashId, onlineStatus} = item
            obj[boxHashId] = Boolean(onlineStatus)
          })
          keys.forEach((craneId) => {
            const {boxHashId} = this.boxes[craneId]
            const item = this.data[craneId]
            if (item) {
              this.data[craneId] = {...item, ...{boxHashId, boxOnline: obj[boxHashId]}}
            }
          })
        }
      })
    },
    // 获取配电箱基础信息
    getBoxBaseInfo () {
      const {boxHashId, boxName} = this.craneObj
      getBoxInfo(boxHashId).then((res) => {
        const {result, code} = res
        if (code === 200) {
          const {
            device: { leakageStatus, temperatureStatus },
            ticketStatus: {is_blackout: isBlackout, is_disconnect: isDisconnect, is_leakage: isLeakage, is_overheat: isOverheat, is_overload: isOverload, is_resi: isResi, is_smoke: isSmoke}
          } = result
          const leakageBranch = []
          const temperatureBranch = []
          const alarmList = []
          leakageStatus.split(',').forEach((item, index) => {
            if (parseInt(item)) {
              leakageBranch.push(index)
            }
          })
          temperatureStatus.split(',').forEach((item, index) => {
            if (parseInt(item)) {
              temperatureBranch.push(index)
            }
          })
          if (isBlackout) alarmList.push(this.$t(alarmContent.is_blackout))
          if (isDisconnect) alarmList.push(this.$t(alarmContent.is_disconnect))
          if (isLeakage) alarmList.push(this.$t(alarmContent.is_leakage))
          if (isOverheat) alarmList.push(this.$t(alarmContent.is_overheat))
          if (isOverload) alarmList.push(this.$t(alarmContent.is_overload))
          if (isResi) alarmList.push(this.$t(alarmContent.is_resi))
          if (isSmoke) alarmList.push(this.$t(alarmContent.is_smoke))
          this.currentBox = {...this.currentBox, ...{alarmList, boxName}}
          this.getBoxRunData(boxHashId, leakageBranch, temperatureBranch)
        }
      })
    },
    // 获取配电箱实时数据
    getBoxRunData (id, leakageBranch, temperatureBranch) {
      getBoxMetric(id).then((res) => {
        const {result, code} = res
        if (code === 200) {
          const { metric, leakages, resi, temperatures } = result
          let {value} = resi
          const { energy_a: energyA, energy_b: energyB, energy_c: energyC } = metric
          let {
            current_a: currentA,
            current_b: currentB,
            current_c: currentC
          } = metric
          currentA = formatterNumber(currentA, 2)
          currentB = formatterNumber(currentB, 2)
          currentC = formatterNumber(currentC, 2)
          const newResi = formatterNumber(value, 2)
          const energyTotal = formatterNumber(energyA + energyB + energyC)
          const leakagesValues = leakages
            .filter((item, index) => leakageBranch.includes(index))
            .filter((item, index) => index < 3)
          const temperaturesValues = temperatures.filter((item, index) =>
            temperatureBranch.includes(index)
          )
          this.currentBox = {...this.currentBox, ...{currentA, currentB, currentC, resi: newResi, energyTotal, leakagesValues, temperaturesValues}}
        }
      })
    },
    callRequest () {
      this.clearLoopTimer()
      this.clearCraneTimer()
      this.clearBoxStatusTimer()
      this.getRunData()
      this.getBoxStatusData()
      this.timerRequest()
      this.timerClickRequest()
      this.timerBoxStatusRequest()
    },
    // 实时数据轮询
    timerRequest () {
      this.loopTimer = setInterval(() => {
        this.getRunData()
        this.getRealData()
      }, 5000)
    },
    // 塔机自动轮询
    timerClickRequest () {
      this.craneTimer = setInterval(() => {
        this.switchClickCrane()
      }, 15000) // 30秒轮询塔机基础信息
    },
    // 统计自动轮询
    timerStaticRequest () {
      this.staticRequestTimer = setInterval(() => {
        this.getProjectDayStaticData()
        this.getDayStaticData()
      }, 300000) // 5分钟
    },
    // 报警信息自动轮询
    timerAlarmAndPeccancyRequest () {
      this.alarmRequestTimer = setInterval(() => {
        this.getAlarmDetail()
        this.getPeccancyDetail()
      }, 60000) // 1分钟
    },
    // 配电箱状态轮询
    timerBoxStatusRequest () {
      this.boxStatusTimer = setInterval(() => {
        this.getBoxStatusData()
      }, 300000) // 5分钟
    },
    switchClickCrane () {
      const dataVal = Object.values(this.data)
      const len = dataVal.length
      if (this.clickIndex < len - 1) {
        this.craneObj = dataVal[this.clickIndex]
        const {hasBox} = this.craneObj
        if (hasBox) this.getBoxBaseInfo()
        this.clickIndex++
      } else {
        this.craneObj = dataVal[this.clickIndex]
        const {hasBox} = this.craneObj
        if (hasBox) this.getBoxBaseInfo()
        this.clickIndex = 0
      }
    },
    getRealData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const {id} = this.projectInfo
      const params = {startDate, endDate, nodeId: id}
      getRealData(params).then((res) => {
        const {data, code} = res
        if (code === 200) {
          const {onlineTotal = 0, total = 0, vtotal = 0, stotal = 0} = data
          const params = {
            craneTotal: total,
            online: onlineTotal,
            num110s: stotal,
            numV610: vtotal
          }
          const onlineRate = !total ? 0 : onlineTotal / total * 100
          this.craneOverview = {...this.craneOverview, ...params}
          this.staticsInfo = {...this.staticsInfo, ...{currentOnlineRate: onlineRate}}
        }
      })
    },
    getProjectDayStaticData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const {id, companyId} = this.projectInfo
      const params = {startDate, endDate, nodeId: companyId}
      getDayStaticData(params).then(res => {
        const {data, code} = res
        if (code === 200) {
          let {list = []} = data
          let preOnlineRate = 0
          let currentAlarm = 0
          let currentTaJunAlarm = 0
          let preAlarm = 0
          let currentPeccancy = 0
          let currentTaJunPeccancy = 0
          let prePeccancy = 0
          let currentHangTimes = 0
          let currentTaJunHangTimes = 0
          let preHangTimes = 0
          let currentWorkTime = 0
          let currentTaJunWorkTime = 0
          let preWorkTime = 0
          list.forEach((obj) => {
            const {nodeId, statDate: factStartDate, totalCrane, totalAlarm, avgAlarm, totalPeccancy, avgPeccancy, avgTotal, total, onlineRate, workDuration} = obj
            if (nodeId === id) {
              const avg = Math.round(totalCrane ? workDuration / totalCrane : 0)
              const result = factStartDate === startDate
              if (!result) {
                currentAlarm = totalAlarm
                currentTaJunAlarm = avgAlarm
                currentPeccancy = totalPeccancy
                currentTaJunPeccancy = avgPeccancy
                currentHangTimes = total
                currentTaJunHangTimes = avgTotal
                currentWorkTime = workDuration
                currentTaJunWorkTime = avg
              } else {
                preOnlineRate = onlineRate * 100
                preAlarm = totalAlarm
                prePeccancy = totalPeccancy
                preHangTimes = total
                preWorkTime = workDuration
              }
            }
          })
          this.staticsInfo = {...this.staticsInfo,
            ...{
              preOnlineRate,
              currentAlarm,
              currentTaJunAlarm,
              preAlarm,
              currentPeccancy,
              currentTaJunPeccancy,
              prePeccancy,
              currentHangTimes,
              currentTaJunHangTimes,
              preHangTimes,
              currentWorkTime,
              currentTaJunWorkTime,
              preWorkTime
            }}
        }
      })
    },
    getDayStaticData () {
      const startDate = dayjs().subtract(1, 'd').format(formatter)
      const endDate = dayjs().format(formatter)
      const {id} = this.projectInfo
      const params = {startDate, endDate, nodeId: id}
      getDayStaticData(params).then(res => {
        const {data, code} = res
        if (code === 200) {
          const {list = []} = data
          const alarmChartData = []
          const peccancyChartData = []
          list.forEach((obj) => {
            const {nodeName, statDate: factStartDate, totalAlarm, totalPeccancy} = obj
            const result = factStartDate === startDate
            if (!result) {
              alarmChartData.push({title: nodeName, total: totalAlarm})
              peccancyChartData.push({title: nodeName, total: totalPeccancy})
            }
          })
          this.alarmChartData = alarmChartData.sort(compare('total', 0))
          this.peccancyChartData = peccancyChartData.sort(compare('total', 0))
        }
      })
    },
    // 获取报警统计数据
    getAlarmDetail () {
      const beginTime = `${dayjs().format(formatter)} 00:00:00`
      const endTime = `${dayjs().format(formatter)} 23:59:59`
      const params = {nodeId: this.projectInfo.id, ticketType: 2, subTicketType: -1, pageSize: 20, pageNumber: 0, beginTime, endTime}
      const data = []
      getAlarmDetail(params).then((res) => {
        const newData = res.data.filter((obj, index) => index < 18)
        newData.forEach((obj) => {
          const {craneName, startTime, endTime, alarmCode} = obj
          const content = this.$t(`${detailType[`${alarmCode}`]}`)
          const newStartTime = dayjs(startTime).format(formatter2)
          const newEndTime = !endTime ? '--' : dayjs(endTime).format(formatter2)
          data.push({craneName, startTime: newStartTime, endTime: newEndTime, content})
        })
        this.alarmList = data
      })
    },
    // 获取违章统计数据
    getPeccancyDetail () {
      const beginTime = `${dayjs().format(formatter)} 00:00:00`
      const endTime = `${dayjs().format(formatter)} 23:59:59`
      const params = {nodeId: this.projectInfo.id, ticketType: 3, subTicketType: -1, pageSize: 20, pageNumber: 0, beginTime, endTime}
      const data = []
      getAlarmDetail(params).then((res) => {
        const newData = res.data.filter((obj, index) => index < 18)
        newData.forEach((obj) => {
          const {craneName, startTime, endTime, alarmCode} = obj
          const content = this.$t(`${detailType[`${alarmCode}`]}`)
          const newStartTime = dayjs(startTime).format(formatter2)
          const newEndTime = !endTime ? '--' : dayjs(endTime).format(formatter2)
          data.push({craneName, startTime: newStartTime, endTime: newEndTime, content})
        })
        this.peccancyList = data
      })
    },
    // 获取萤石云token
    getYSAccessToken () {
      getYSToken().then((res) => {
        const {code, data} = res
        if (code === 200 && data) {
          this.ysToken = data
        }
      })
    },
    init () {
      let auth = sessionStorage.getItem('authorization')
      const params = this.getUrlParams()
      const {token, projectId} = params
      if (!auth) {
        if (!projectId || !token) {
          this.$router.push('/')
        } else {
          sessionStorage.setItem('authorization', token)
          this.getProject(projectId)
          this.getYSAccessToken()
        }
      } else {
        this.getProject(projectId)
        this.getYSAccessToken()
      }
    },
    // 获取url参数
    getUrlParams () {
      const params = {}
      const href = window.location.href
      const searchIndex = href.indexOf('?')
      if (searchIndex > -1) {
        const search = href.substring(searchIndex + 1)
        const paramsStr = search.split('&')
        paramsStr.forEach(res => {
          const str = res.split('=')
          params[str[0]] = str[1]
        })
      }
      return params
    },
    // 铺满全屏
    resizeFull () {
      const ratioX = window.innerWidth / 1920
      const ratioY = window.innerHeight / 1080
      $('#home-bg').css({
        transform: 'scale(' + ratioX + ', ' + ratioY + ')',
        transformOrigin: 'left top',
        backgroundSize: '100% 100%'
      })
    },
    addEvenListener () {
      const self = this
      window.onresize = function () {
        self.isScreenChange = Math.random()
        self.resizeFull()
      }
    },
    // 刷新token
    refreshTokenRequest () {
      this.refreshTimer = refreshToken().then(res => {
        const {data, code} = res
        if (code === 200) {
          sessionStorage.setItem('authorization', data)
        }
      })
    },
    // 定时刷新
    refreshTokenTimer () {
      setInterval(() => {
        this.refreshTokenRequest()
      }, 86400)
    },
    // 塔的的轮询
    clearCraneTimer () {
      if (this.craneTimer) clearInterval(this.craneTimer)
    },
    clearLoopTimer () {
      if (this.loopTimer) clearInterval(this.loopTimer)
    },
    clearBoxStatusTimer () {
      if (this.boxStatusTimer) clearInterval(this.boxStatusTimer)
    },
    clearStaticTimer () {
      if (this.staticRequestTimer) clearInterval(this.staticRequestTimer)
    },
    clearAlarmTimer () {
      if (this.alarmRequestTimer) clearInterval(this.alarmRequestTimer)
    },
    clearRefreshTokenTimer () {
      if (this.refreshTimer) clearInterval(this.refreshTimer)
    }
  },
  mounted () {
    this.addEvenListener()
    this.resizeFull()
    this.init()
    this.refreshTokenTimer()
  },
  // 实时数据10秒，塔机轮询2分钟， 统计轮询5分钟， 报警统计1分钟
  destroyed () {
    this.clearLoopTimer()
    this.clearStaticTimer()
    this.clearCraneTimer()
    this.clearAlarmTimer()
    this.clearRefreshTokenTimer()
  }
}
</script>

<style scoped lang="scss">
  #home-bg{
    width:1920px;
    height:1080px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue